import { Controller } from 'stimulus'

export default class CommunityController extends Controller {
  static targets = ['upcomingEvents', 'pastEvents', 'upcomingEventsTrigger', 'pastEventsTrigger']

  static values = {
    activeButtonClass: String,
    activeContainerClass: String,
  }

  connect() {
    this.autoSelectEventTabs()
  }

  switchSelectedButton(element) {
    element.parentElement.querySelector(`.${this.activeButtonClassValue}`).classList.remove(this.activeButtonClassValue)
    element.classList.add(this.activeButtonClassValue)
  }

  showUpcomingEvents() {
    const target = this.upcomingEventsTriggerTarget

    if (!target.classList.contains(this.activeButtonClassValue)) {
      this.upcomingEventsTarget.classList.add(this.activeContainerClassValue)
      this.pastEventsTarget.classList.remove(this.activeContainerClassValue)

      this.switchSelectedButton(target)
    }
  }

  showPastEvents() {
    const target = this.pastEventsTriggerTarget

    if (!target.classList.contains(this.activeButtonClassValue)) {
      this.upcomingEventsTarget.classList.remove(this.activeContainerClassValue)
      this.pastEventsTarget.classList.add(this.activeContainerClassValue)

      this.switchSelectedButton(target)
    }
  }

  autoSelectEventTabs() {
    const isUpcomingEmpty = this.upcomingEventsTarget.classList.contains('events__upcoming-events--empty')

    if (isUpcomingEmpty) {
      this.showPastEvents({ target: this.pastEventsTriggerTarget })
    }
  }
}
